import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  input,
  output,
  TemplateRef
} from '@angular/core';
import { IconDirective } from '@coreui/icons-angular';
import { ServerAuthUrlPipe } from 'auth';
import { DownloadService, Logger } from 'shared';
import { MediaService } from '../../media.service';
import { Media } from '../../models/media';
import { MediaIconComponent } from '../media-icon/media-icon.component';

type LoadedUrl = {
  src: string;
  loaded: boolean;
  transitioned: boolean;
  maxWidth: number;
  fallback: boolean;
};

@Component({
  selector: 'media-card',
  templateUrl: './media-card.component.html',
  styleUrls: ['./media-card.component.scss'],
  imports: [CommonModule, IconDirective, MediaIconComponent, ServerAuthUrlPipe],
  host: {
    '[class.elevated]': 'elevated()',
    '[class.rounded]': 'rounded()',
    '[class.selectable]': 'selectable()',
    '[class.selected]': 'selected()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaCardComponent {

  readonly Media = Media;
  media = input.required<Media>();
  detailsTemplate = input<TemplateRef<{ media: Media }>>();
  play = output();
  onCoverLoaded = output<Media>();

  imageMaxWidth = input<number>(640);
  defaultCover = input<boolean>(false);
  defaultCoverHeight = input<number>(9/16 * 100); // default cover height in percent of width
  forcedCoverHeight = input<number>(); // forced cover height in percent of width
  backgroundColor = input<string>('transparent');

  elevated = input<boolean>(true);
  rounded = input<boolean>(true);
  selectable = input<boolean>(true); // reserves space for selection by rendering a transparent 2px border
  selected = input<boolean>(false);

  mediaTypeIcon = input<boolean>(true);

  // @HostBinding('class.elevated') isElevated = computed(() => this.elevated());
  // @HostBinding('class.rounded') isRounded = computed(() => this.rounded());
  // @HostBinding('class.selectable') isSelectable = computed(() => this.selectable());
  // @HostBinding('class.selected') isSelected = computed(() => this.selected());

  // @HostBinding('class.rounded')    get isRounded():boolean {return this.rounded()};
  // @HostBinding('class.selectable') get isSelectable():boolean {return this.selectable()};
  // @HostBinding('class.selected')   get isSelected():boolean {return this.selected()};

  // cover = signal(undefined);

  protected static loadedUrls = new Map<string, LoadedUrl>();

  download = computed(() => {
    const media = this.media();
    const download = media?.properties?.download;
    if (typeof download === 'string') {
      return (download as string).toLowerCase() === 'true';
    } else {
      return download;
    }
  });
  select = output();

  protected logger = new Logger('MediaCardComponent')

  constructor(public mediaService: MediaService,
              protected downloadService: DownloadService,
              protected elementRef: ElementRef) {
      effect(() => {
        this.media();
        // this.updateCover();
      });
    // afterRenderEffect(() => {});
  }

  onCoverClick(event: Event) {
    this.logger.info('onCoverClick', this.media);
    let target = event.target as Element;
    let download = false;
    do {
      download = target.classList.contains('download');
    } while (!download && (target = target.parentElement!));
    
    if (download) {
      const media = this.media();
      const src = media?.links?.[0].src;
      if (src) {
        event.preventDefault();
        event.stopPropagation();
        this.downloadService
            .download(src, this.elementRef.nativeElement)
            .catch(error =>  this.logger.error('Failed to download media', { error, media: this.media }));
      }
    } else {
      this.select.emit();
    }
  }
}
